import { PAYMENT_METHOD } from '@store/payment/constants';

export const isBankTransfer = (
  data: Record<string, string | Record<string, string>>
) => {
  const { paymentMethod } = data;
  return paymentMethod === PAYMENT_METHOD.indonesianBankTransfer;
};
